<script lang="ts">
    
    import type { FigureName } from "../../global";
    import { i18n } from "../../Services/i18n";

    export let name: FigureName;

    const namesMap = {
        'line'      : 'Línea',
        'column'    : 'Columna',
        'diagonal'  : 'Diagonal',
        'corners'   : 'Esquinas'
    };

    $: text = $i18n(namesMap[name]);

</script>

<slot {text}>{text}</slot>
